import React from 'react';

export default function IcArrowDown(props) {
  return (
    <svg width='1em' height='1em' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M16.7071 14.2929C17.0976 14.6834 17.0976 15.3166 16.7071 15.7071L12.7071 19.7071C12.3166 20.0976 11.6834 20.0976 11.2929 19.7071L7.29289 15.7071C6.90237 15.3166 6.90237 14.6834 7.29289 14.2929C7.68342 13.9024 8.31658 13.9024 8.70711 14.2929L11 16.5858L11 5C11 4.44771 11.4477 4 12 4C12.5523 4 13 4.44772 13 5L13 16.5858L15.2929 14.2929C15.6834 13.9024 16.3166 13.9024 16.7071 14.2929Z" 
        fill="currentColor" />
    </svg>
  );
}
